var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBackTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876:2728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7199 7.20147L42.5129 6.96702L42.2874 4.27958L34.6481 4.92072L35.2894 12.56L37.9768 12.3344L37.696 8.98815C41.2861 12.7409 43.3031 17.7174 43.3031 22.9999C43.3031 28.423 41.1912 33.5215 37.3565 37.3563C33.5218 41.1911 28.4232 43.3029 23 43.3029C17.5769 43.3029 12.4783 41.1912 8.64349 37.3565C4.80871 33.5218 2.69688 28.4232 2.69688 23C2.69688 17.5769 4.8088 12.4783 8.64349 8.64349C12.4782 4.80871 17.5768 2.69688 23 2.69688V0C16.8566 0 11.0807 2.3924 6.73662 6.73662C2.3924 11.0807 0 16.8565 0 23C0 29.1436 2.3924 34.9193 6.73662 39.2635C11.0807 43.6076 16.8566 46.0001 23 46.0001C29.1435 46.0001 34.9193 43.6077 39.2635 39.2635C43.6076 34.9193 46.0001 29.1435 46.0001 23C46 17.051 43.7424 11.4441 39.7199 7.20147Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6515 11.9541V8.79401C14.8571 9.43389 9.43389 14.857 8.79401 21.6515H11.9541V24.3484H8.79401C9.43389 31.1428 14.857 36.5661 21.6515 37.206V34.0459H24.3484V37.206C31.1428 36.5661 36.5661 31.1429 37.206 24.3484H34.0459V21.6515H37.206C36.5661 14.8571 31.1429 9.43389 24.3484 8.79401V11.9541H21.6515ZM24.3484 23.6276L19.2742 27.8972L17.5378 25.8337L21.6515 22.3723V14.79H24.3484V23.6276Z",
    fill: "#5BA1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876:2728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackTime);
export default __webpack_public_path__ + "static/media/icon-back-time.e0415fe6.svg";
export { ForwardRef as ReactComponent };